<script>
    import TabButton from "./TabButton";

    export default {
        name: "Tabs",

        model: {
            event: 'change'
        },

        props: {
            value: Number | Object,
            allowToActivateFirstTab: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                tabs: [],
                activeTab: null,
            }
        },

        provide() {
            return {
                tabs: {
                    activeTab: () => this.activeTab,
                    registerTab: this.registerTab,
                    setActiveTab: this.setActiveTab
                }
            }
        },

        render(createElement) {
            const tabs = this.tabs.map(tab => createElement(
                TabButton, {
                    props: {tab}
                }
            ));

            const ulElement = createElement('ul', tabs);
            const navElement = createElement('nav', {attrs: {class: 'tabs'}}, [ulElement]);

            return createElement(this.tag || 'div', [navElement, ...this.$slots.default]);
        },

        destroyed() {
            this.tabs = [];
        },

        watch: {
            value: {
                immediate: true,
                handler(to) {
                    this.setActiveTab(this.tabs.find(tab => tab.value === to));
                }
            },

            activeTab(to) {
                if (this.noTabActive && this.tabs.length > 0) {
                    this.setFirstValidTabAsActive();
                }

                this.$emit('change', to.value);
            },

            tabs(to) {
                if (to && to.length > 0 && this.noTabActive) {
                    this.setFirstValidTabAsActive();
                }
            }
        },

        computed: {
            noTabActive() {
                return this.activeTab === undefined || this.activeTab === null;
            }
        },

        methods: {
            registerTab(tab) {
                if (this.tabs.indexOf(tab) < 0) {
                    this.tabs.push(tab);

                    tab.$once('hook:destroyed', () => {
                        this.unregisterTab(tab)
                    });
                }
            },

            unregisterTab(tab) {
                this.tabs = this.tabs.slice().filter(t => t !== tab);
            },

            setActiveTab(tab) {
                this.activeTab = tab;
            },

            setFirstValidTabAsActive() {
                if (!this.allowToActivateFirstTab) return;
                this.setActiveTab(this.tabs.find(tab => this.value === undefined || this.value === null || tab.value === this.value));
            }
        }
    }
</script>